const WORDS = ["Design floreale su misura", "Wedding florist", "Bouquet di stagione", "Allestimenti in Puglia", "Composizioni d'autore"];

export const Marquee = ({ dark = false }) => {
  const row = (
    <div className="flex shrink-0 items-center gap-12 pr-12">
      {WORDS.map((w) => (
        <span key={w} className="flex items-center gap-12">
          <span className="font-serif italic text-4xl sm:text-6xl lg:text-7xl whitespace-nowrap">{w}</span>
          <span className={`w-2.5 h-2.5 rounded-full shrink-0 ${dark ? "bg-sage" : "bg-[#68735B]"}`} />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="editorial-marquee" className={`overflow-hidden py-10 sm:py-14 border-y ${dark ? "bg-cypress text-cream border-cream/10" : "bg-sand text-cypress border-stone"}`}>
      <div className="flex w-max animate-marquee">
        {row}
        {row}
      </div>
    </div>
  );
};
